import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const LoadingCheckmark: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.11133 11.4727C3.50088 12.0196 3.97898 12.4977 4.52592 12.8872"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08748 6.99805C1.96742 7.65959 1.96742 8.33734 2.08748 8.99888"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.11133 4.52463C3.50068 3.97733 3.9788 3.49898 4.52592 3.10938"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M6.99805 13.9113C9.35656 14.3245 11.735 13.2964 13.05 11.2954C14.3651 9.29439 14.3651 6.70325 13.05 4.70225C11.735 2.70125 9.35656 1.67319 6.99805 2.08636"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.67433 7.13672L7.58079 9.23026L6.32227 7.97573"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
